import { render, staticRenderFns } from "./TgCjElegance.vue?vue&type=template&id=66287a30&"
import script from "./TgCjElegance.vue?vue&type=script&lang=js&"
export * from "./TgCjElegance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports